import m from 'mithril'
import {classes, Component, Icon} from '@codeurs/front'
import {facebookLink, twitterLink, linkedInLink} from 'util/share'

import './share.less'

export default class Share extends Component<{
	text?: string
	class?: string
	desc?: string
	mod?: string
}> {
	view() {
		const {text, class: className} = this.attrs

		return m('.share', classes(className), [
			text && m('p.share-text', text),
			m('.share-row', [
				this.viewShareLink('facebook'),
				this.viewShareLink('twitter'),
				this.viewShareLink('linkedin')
			])
		])
	}

	viewShareLink(type) {
		const {mod} = this.attrs
		return m('a.share-link',
			{
				...classes({mod: `${type} ${mod}`}),
				...this.sharePlatform(type)
			},
			m(Icon, {icon: type, class: 'share-link-icon'})
		)
	}

	sharePlatform(type) {
		const {desc} = this.attrs
		if (!type) return null
		switch (type) {
			case 'facebook':
				return facebookLink(window.location.href)
			case 'twitter':
				return twitterLink(desc, window.location.href)
			case 'linkedin':
				return linkedInLink(window.location.href)
		}
	}
}
